import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the SwIllustrationPage state domain
 */

const selectSwIllustrationPageDomain = state =>
  state.get('swIllustrationPage', initialState);

/**
 * Other specific selectors
 */

/**
 * Default selector used by SwIllustrationPage
 */

const makeSelectSwIllustrationPage = () =>
  createSelector(selectSwIllustrationPageDomain, substate => substate.toJS());

const makeSelectLifeAssured = () =>
  createSelector(selectSwIllustrationPageDomain, substate =>
    substate.get('lifeAssured').toJS(),
  );

const makeSelectInitialLifeAssured = () =>
  createSelector(selectSwIllustrationPageDomain, substate =>
    substate.get('initialLifeAssured').toJS(),
  );

const makeSelectError = () =>
  createSelector(selectSwIllustrationPageDomain, substate =>
    substate.get('errorData').toJS(),
  );

const makeSelectConfig = () =>
  createSelector(selectSwIllustrationPageDomain, substate =>
    substate.get('swConfig').toJS(),
  );

const makeSelectBiTableValues = () =>
  createSelector(selectSwIllustrationPageDomain, substate =>
    substate.get('biTableValues').toJS(),
  );

const makeSelectFiaCharge = () =>
  createSelector(selectSwIllustrationPageDomain, substate =>
    substate.get('fiaData').toJS(),
  );

const makeSelectProductConfig = () =>
  createSelector(selectSwIllustrationPageDomain, substate =>
    substate.get('productConfig').toJS(),
  );

const makeSelectQuoteId = () =>
  createSelector(selectSwIllustrationPageDomain, substate =>
    substate.get('quoteId'),
  );

const makeSelectApplicationId = () =>
  createSelector(selectSwIllustrationPageDomain, substate =>
    substate.get('applicationId'),
  );

const makeSelectBiPdf = () =>
  createSelector(selectSwIllustrationPageDomain, substate =>
    substate.get('benefitIllustrationPdf'),
  );

const makeSelectStatus = () =>
  createSelector(selectSwIllustrationPageDomain, substate =>
    substate.get('status'),
  );

const makeSelectReferenceNumber = () =>
  createSelector(selectSwIllustrationPageDomain, substate =>
    substate.get('referenceNumber'),
  );

const makeSelectCloneStatus = () =>
  createSelector(selectSwIllustrationPageDomain, substate =>
    substate.get('successClone'),
  );

const makeSelectemailSentStatus = () =>
  createSelector(selectSwIllustrationPageDomain, substate =>
    substate.get('emailSent'),
  );

const makeSelectEmailErrorMessage = () =>
  createSelector(selectSwIllustrationPageDomain, substate =>
    substate.get('emailErrorMessage'),
  );

const makeSelectFormInput = () =>
  createSelector(selectSwIllustrationPageDomain, substate =>
    substate.get('input').toJS(),
  );

export {
  makeSelectSwIllustrationPage,
  makeSelectLifeAssured,
  makeSelectProductConfig,
  makeSelectFiaCharge,
  makeSelectConfig,
  makeSelectError,
  makeSelectQuoteId,
  makeSelectApplicationId,
  makeSelectBiPdf,
  makeSelectStatus,
  makeSelectReferenceNumber,
  makeSelectInitialLifeAssured,
  makeSelectBiTableValues,
  makeSelectCloneStatus,
  makeSelectemailSentStatus,
  makeSelectEmailErrorMessage,
  makeSelectFormInput,
};
